import { AbstructLang } from "../../../general/general-component/abstruct-component/AbstructLang";



export const ItemsProjectReviewSystem = () => {

    const { translate } = AbstructLang();

    const items = [
        {
            title: translate('ScriptsTypes'),
            icon: "fa-solid fa-film",
            url: "/project-types",
            id: 1
        },
        {
            title: translate('ScriptsRequests'),
            icon: "fa-solid fa-list-check",
            url: "/project-request",
            id: 2
        },
        {
            title: translate('EvaluationTypes'),
            icon: "fas fa-check-circle",
            url: "/evaluation-types",
            id: 3
        },
        {
            title: translate('scripts_archive'),
            icon: "fa-solid fa-archive",
            url: "/scripts-archive",
            id: 4
        }
    ]
    return {
        items
    }
}